export const companionType: any = {
  partner: "恋人",
  family: "家族",
  friend: "友達",
  single: "一人",
  business: "仕事",
};
